(function($) {

	$.fn.navigator = function() {

		var elem = $(this),
			content = elem.find('.js-navigator__content'),
			sidebar = elem.find('.js-navigator__sidebar'),
			siteHead = $('.js-site__head'),
			body = $('body'),
			settings = {
				debounceTimeout: 500,
				paddingVariant: 20,
				calculateHeight: true
			};

		var init = function() {

            // Parse settings
            settings = $.extend(true, {}, settings, elem.parseSettings());

            // If height calculation is required
			if(settings.calculateHeight) {

				// Run once then bind to resize
				calculateMinHeight();

				// Debounce that mofo
				$(window).resize(debounce(calculateMinHeight));
			}

		},

		// Make the navigator layout fill the screen
		calculateMinHeight = function() {
			var calcHeight = (body.height() + settings.paddingVariant) - siteHead.height();

			content.css('min-height', calcHeight);
			sidebar.css('min-height', calcHeight);
		};

		init();
		return this;
	};

}($));